import styled from "@emotion/styled";

const RaffleSectionTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--tw-gray-800);
`;

export default RaffleSectionTitle;
